import { makeAutoObservable, runInAction } from 'mobx'
import { apiService } from '@/services/Api'
import { UserMeta, User as IUser, Role } from '@/services/Api/generated'

export class User {
  uuid = null
  name = ''
  lastname = ''
  patronomic = ''
  email = ''
  phone = ''
  active = false
  emailVerified = false
  roles: Role[] = []
  agreementAccepted: null | string = ''
  instructionPassed: boolean = false

  get isAdmin() {
    return this.roles.includes(Role.Admin)
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  setData(userData: IUser) {
    this.uuid = userData.uuid
    this.name = userData.name
    this.lastname = userData.lastname
    this.patronomic = userData.patronymic
    this.email = userData.email
    this.phone = userData.phone
    this.active = userData.active
    this.emailVerified = userData.emailVerified
    this.roles = userData.roles
    this.agreementAccepted = userData.agreementAccepted
    this.instructionPassed = userData.instructionPassed
  }

  metaData: UserMeta = {
    organizationType: null,
    organizationData: null,
  }

  async getMetaData() {
    const response = await apiService.user.getMeta()
    if (response.status && response.data) {
      runInAction(() => {
        this.metaData.organizationType = response.data.organizationType
        this.metaData.organizationData = response.data.organizationData
      })
    }
  }

  async getUserData() {
    const response = await apiService.user.getContactData()
    if (response.status) {
      this.setData(response.data.user)
    }
  }

  reset() {
    this.metaData.organizationType = null
    this.metaData.organizationData = null

    this.setData({
      uuid: null,
      name: '',
      lastname: '',
      patronymic: '',
      email: '',
      phone: '',
      active: false,
      emailVerified: false,
      roles: [],
      instructionPassed: false,
    })
  }

  setName(name: string) {
    this.name = name
  }
}

export const userStore = new User()
